import type { KeyboardEvent, ReactElement } from "react";
import { useState } from "react";

import { DotsLoader } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";

import {
    StyledAddNewChipTextfield,
    StyledEditableChipCloseButton,
    StyledEditableChipInputContainer,
    StyledEditableChipItemWrapper,
} from "./styles";

interface IProps {
    isLoading?: boolean;
    onApplyClick?: (value: string) => void;
    onCloseClick?: () => void;
}

const EditableChipItem = ({ isLoading, onApplyClick, onCloseClick }: IProps): ReactElement => {
    const [fieldValue, setFieldValue] = useState<string>("");

    const handleKeyUp = (event: KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "Enter" && onApplyClick) {
            onApplyClick(fieldValue);
        }
    };

    return (
        <StyledEditableChipItemWrapper>
            <Flex alignItems="center">
                <StyledEditableChipInputContainer>
                    <StyledAddNewChipTextfield
                        autoFocus
                        isLoading={isLoading}
                        placeholder={translate("si.onboarding.editable-chip.placeholder")}
                        ApplyButtonText={translate("si.common.button.add")}
                        onApplyClick={() => onApplyClick?.(fieldValue)}
                        onChange={setFieldValue}
                        onKeyUp={handleKeyUp}
                        loadingComponent={<DotsLoader />}
                    />
                </StyledEditableChipInputContainer>

                <StyledEditableChipCloseButton
                    iconName="close"
                    type="flat"
                    iconSize="xs"
                    onClick={onCloseClick}
                    isDisabled={isLoading}
                />
            </Flex>
        </StyledEditableChipItemWrapper>
    );
};

export default EditableChipItem;
